<app-dialog
  [title]="title"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Save',
      spin: spin,
      isDisabled: !form.valid || spin
    }
  ]"
  (action)="action($event)"
  (close)="close()"
>
  <app-item-typeahead *ngIf="vendorInfo"
          [name]="vendorInfo?.name"
          [id]="vendorInfo?.id"
          [image]="vendorInfo?.image"
          [isVendorItem]="true"
  ></app-item-typeahead>
  <div class="form" [formGroup]="form">
    <div class="input-container">
      <label for="" class="input-container_label">Vendor<span class="input-container_asterisk">*</span></label>
      <input
        type="text"
        class="input-container_input"
        formControlName="vendor"
        [matAutocomplete]="auto"
        placeholder="Search"
        (focusout)="focusOut()"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith">
        <mat-option
          *ngFor="let option of filteredOptions$ | async"
          [value]="option"
          class="mat-option-override"
        >
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="input-container">
      <label for="" class="input-container_label">Vendor Item Name <span class="input-container_asterisk">*</span></label>
      <input
        type="text"
        class="input-container_input"
        formControlName="vendorItemName"
        (keypress)="restrictSpecialChar($event)"
        (input)="onChange($event)"
      />
      <div
        class="input-container_error-message"
        *ngIf="form.controls['vendorItemName'].errors?.unique"
      >
        Item name already exists for this vendor
      </div>
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Price<span class="input-container_asterisk">*</span></label>
      <div class="input-container_wrapper">
        <input
          type="number"
          class="input-container_input input-container_input--number"
          formControlName="price"
        />
        <div class="input-container_icon input-container_icon--no-background">
          $
        </div>
      </div>
    </div>   

    <div class="input-container">
      <label for="" class="input-container_label">Minimum Order Qty (MOQ)</label>
      <input
        type="number"
        class="input-container_input"
        formControlName="minimumOrderQty"
      />
    </div>   
    <div class="input-container input-container--w100">
      <label for="" class="input-container_label">Note</label>
      <input class="input-container_input" formControlName="note" />
    </div>
    
    <app-page-container-devider [title]="'Case Settings'" [small]="true"
    class="input-container--w100 my-3"></app-page-container-devider>

    <div class="input-container">
      <label for="" class="input-container_label">Case Qty<span class="input-container_asterisk">*</span></label>
      <input
        type="number"
        class="input-container_input"
        formControlName="caseQty"
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Case Rounding Setting<span class="input-container_asterisk">*</span></label>
      <select
        type="number"
        class="input-container_input input-container_input--select"
        formControlName="caseRoundingSetting"
      >
        <option value="up">Up</option>
        <option value="down">Down</option>
        <option value="nearest">Nearest</option>
        <option value="none">None</option>
        , , ,
      </select>
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Length</label>
      <input
         type="number"
         min="0"
         class="input-container_input"
         formControlName="length"
      />
    </div>
    <div class="input-container">
      <label for="" class="input-container_label">Width</label>
      <input
        type="number"
        min="0"
        class="input-container_input"
        formControlName="width"
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Height</label>
      <div class="input-container_wrapper">
        <input
          type="number"
          min="0"
          class="input-container_input"
          formControlName="height"
        />
      </div>
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Weight</label>
      <input
       type="number"
       min="0"
       class="input-container_input"
        formControlName="weight"
      />
    </div>

    <app-page-container-devider [title]="'Vendor Settings'" [small]="true"
      class="input-container--w100 my-3"></app-page-container-devider>

    <div class="input-container">
      <label for="" class="input-container_label">Qty Per Vendor Unit </label>
      <input
      type="number"
      class="input-container_input"
      formControlName="qtyPerVendorUnit"
      (focus)="showWarning = !showWarning" 
      (blur)="showWarning = !showWarning" 
    />
    <div *ngIf="showWarning" class="text-warning mt-1 font-12"><i class="far fa-exclamation-triangle me-1"></i> Changes will not apply to current stock or existing PO's</div>
  </div>
  </div>
</app-dialog>
